import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["nav-link", _ctx.selectedClass])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["bi", _ctx.iconClass])
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
    ], 2)
  ]))
}